import React,{ Fragment } from 'react'
import { Box } from '@chakra-ui/react';
import AllSettlement from '../../component/AllSettlement';



const SettlementAll = () => {
  return (
        <Fragment>
          <Box p={5} flex="1" w={'100%'}>
        <AllSettlement
          title={'All Settlements'}
          head={["Order ID", "Customer Name", "Tenure ID", "Settlement Amount", "Settlement Type", "Settlement Status", ""]}
          data={[{order_id: '#178987', customer_name: 'Ankit Sharma', tenure_id: '#178987', settlement_amount: '6000', settlement_damage: 'No Damage', settlement_status: 'Calculated'},{order_id: '#178987', customer_name: 'Ankit Sharma', tenure_id: '#178987', settlement_amount: '6000', settlement_damage: 'No Damage', settlement_status: 'Confirmed'},{order_id: '#178987', customer_name: 'Ankit Sharma', tenure_id: '#178987', settlement_amount: '6000', settlement_damage: 'No Damage', settlement_status: 'Raised'},{order_id: '#178987', customer_name: 'Ankit Sharma', tenure_id: '#178987', settlement_amount: '6000', settlement_damage: 'No Damage', settlement_status: 'Disputed'}]}/>
         </Box>
        </Fragment>
  )
}

export default SettlementAll